export interface ScrollSnapshot {
  currentPage: number;
  totalPages: number;
  following: boolean;
  hasNewText: boolean;
}

export class AnswerScroller {
  readonly panel: HTMLElement;
  readonly distance: number;
  following = true;
  hasNewText = false;

  constructor(panel: HTMLElement, distance = 96) {
    this.panel = panel;
    this.distance = distance;
  }

  isNearBottom(): boolean {
    return this.panel.scrollHeight - this.panel.scrollTop - this.panel.clientHeight <= 24;
  }

  contentWillUpdate(): boolean {
    return this.following || this.isNearBottom();
  }

  contentDidUpdate(wasFollowing: boolean): ScrollSnapshot {
    if (wasFollowing) {
      this.jumpLatest();
    } else {
      this.following = false;
      this.hasNewText = true;
    }
    return this.snapshot();
  }

  scroll(direction: "up" | "down"): ScrollSnapshot {
    if (direction === "up") {
      this.panel.scrollTop = Math.max(0, this.panel.scrollTop - this.distance);
      this.following = false;
    } else {
      this.panel.scrollTop = Math.min(this.panel.scrollHeight, this.panel.scrollTop + this.distance);
      if (this.isNearBottom()) {
        this.following = true;
        this.hasNewText = false;
      }
    }
    return this.snapshot();
  }

  jumpLatest(): ScrollSnapshot {
    this.panel.scrollTop = this.panel.scrollHeight;
    this.following = true;
    this.hasNewText = false;
    return this.snapshot();
  }

  snapshot(): ScrollSnapshot {
    const pageSize = Math.max(1, this.panel.clientHeight);
    const totalPages = Math.max(1, Math.ceil(this.panel.scrollHeight / pageSize));
    const currentPage = Math.min(totalPages, Math.floor(this.panel.scrollTop / pageSize) + 1);
    return { currentPage, totalPages, following: this.following, hasNewText: this.hasNewText };
  }
}

